// 保存用户信息
export function saveUserInfo(vm) {
  let userInfo = window.sessionStorage.getItem("login-user-info");
  if (userInfo) {
    let data = JSON.parse(userInfo);
    vm.$store.commit("ADD_USER_INFO", data);
  }
}

// 请求品牌商型号
export async function loadBrandOwnerProduct(vm, brandOwnerCode, back) {
  try {
    if (brandOwnerCode) {
      let res = await vm.$http.get(vm.$api.common.loadBrandOwnerProduct, {
        params: { brandOwnerCode }
      });
      if (res.data.status != 200) {
        vm.$message.error(res.data.desc);
        return;
      }
      if (back) {
        vm.$store.commit(
          "ADD_BRAND_OWNER_PRODUCT",
          res.data.data["brandOwnerProductList"]
        );
      }
      return res.data.data["brandOwnerProductList"];
    }
  } catch (e) {
    console.log("加载品牌商产品失败", e);
  }
}

// 加载品牌商子品牌
export async function loadSubBrand(vm, brandOwnerCode, back) {
  try {
    if (brandOwnerCode) {
      let res = await vm.$http.get(vm.$api.common.loadSubBrand, {
        params: { brandOwnerCode }
      });
      if (res.data.status != 200) {
        vm.$message.error(res.data.desc);
        return;
      }
      if (!back) {
        vm.$store.commit("ADD_SUB_BRAND_LIST", res.data.data["subBrandList"]);
      }
      return res.data.data["subBrandList"];
    }
  } catch (e) {
    console.log("加载品牌商产品失败", e);
  }
}

// 加载子品牌型号
export async function loadSubBrandProduct(vm, subBrandCode) {
  try {
    if (subBrandCode) {
      let res = await vm.$http.get(vm.$api.common.loadSubBrandProduct, {
        params: { subBrandCode }
      });
      if (res.data.status != 200) {
        vm.$message.error(res.data.desc);
        return;
      }
      return res.data.data["subBrandProductList"];
    }
  } catch (e) {
    console.log("加载子品牌型号失败", e);
  }
}

// 角色列表
export async function sysRoleList(vm) {
  try {
    let res = await vm.$http.get(vm.$api.sysRole.list, {
      params: { onPage: false }
    });
    if (res.data.status != 200) {
      vm.$message.error(res.data.desc);
      return;
    }
    vm.$store.commit("ADD_SYS_ROLE_LIST", res.data.data["sysRoles"]);
    return res.data.data["sysRoles"];
  } catch (e) {
    console.log("获取角色列表失败", e);
  }
}

// 请求国家列表
export function loadCountry(vm) {
  try {
    vm.$http
      .get(vm.$api.common.loadCountry)
      .then(res => {
        if (res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.$store.commit("ADD_COUNTRY", res.data.data["countryList"]);
      })
      .catch(err => {
        console.log("请求加载国家失败", err);
      });
  } catch (e) {
    console.log("加载国家失败", e);
  }
}

// 用户列表
export function getUserList(vm) {
  try {
    vm.$http
      .get(vm.$api.user.list, { params: { onPage: false } })
      .then(res => {
        if (res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.$store.commit("ADD_USER_LIST", res.data.data["users"]);
      })
      .catch(err => {
        console.log("请求用户列表失败", err);
      });
  } catch (e) {
    console.log("加载用户列表失败", e);
  }
}

// 加载字典
export async function loadDict(vm, dictTypeFlag, key) {
  try {
    let { data: res } = await vm.$http.get(vm.$api.common.loadDict, {
      params: { dictTypeFlag }
    });
    if (res.status != 200) {
      vm.$message.error(res.data.desc);
      return;
    }
    if (key) {
      vm.$store.commit(key, res.data["dictList"]);
    }
    return res.data["dictList"];
  } catch (e) {
    console.log("加载字典失败", e);
  }
}

// 加载系统设置的支持语言
export async function loadSysSettLang(vm) {
  try {
    let res = await vm.$http.get(vm.$api.sysSupportLang.list);
    if (res.data.status != 200) {
      vm.$message.error(res.data.desc);
      return [];
    }
    vm.$store.commit("ADD_SYS_SET_LANG", res.data.data["lang"]);

    return res.data.data["lang"];
  } catch (e) {
    console.log("加载系统设置的支持语言失败", e);
  }
}

// 加载系统支持语言
export function loadSysSupportLang(vm) {
  try {
    vm.$http
      .get(vm.$api.common.loadSysSupportLang, {params: {onPage: false}})
      .then(res => {
        if (res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.$store.commit(
          "ADD_SUPPORT_LANG_LIST",
          res.data.data["supportLangList"]
        );
      })
      .catch(err => {
        console.log("请求加载系统支持语言失败", err);
      });
  } catch (e) {
    console.log("加载加载系统支持语言失败", e);
  }
}

// 加载所有产品
export function loadProduct(vm) {
  try {
    vm.$http
      .get(vm.$api.common.loadProduct)
      .then(res => {
        if (res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.$store.commit("ADD_PRODUCT_LIST", res.data.data["productList"]);
      })
      .catch(err => {
        console.log("请求加载产品失败", err);
      });
  } catch (e) {
    console.log("加载产品失败", e);
  }
}

// 下载模板
export function downloadTemplate(vm, fileName) {
  try {
    let downloadElement = document.createElement("a");
    let param = "?fileName=" + fileName;
    console.log("param", param);
    downloadElement.href = vm.$api.common.downloadImportAccountTpl + param;
    downloadElement.click();
  } catch (e) {
    console.log("下载模板失败", e);
  }
}

// 下载文件
export function downloadFile(vm, fileName) {
  try {
    let downloadElement = document.createElement("a");
    let param = "?fileCode=" + fileName;
    console.log("param", param);
    downloadElement.href = vm.$api.file.download + param;
    downloadElement.click();
  } catch (e) {
    console.log("下载文件失败", e);
  }
}

// 食谱标签列表
export async function recipeTagList(vm) {
  try {
    let data = {
      brandOwnerCode: vm.$store.state.userInfo["brandOwnerCode"],
      onPage: false
    };
    let res = await vm.$http.get(vm.$api.recipeTag.list, { params: data });
    if (res.data.status != 200) {
      vm.$message.error(res.data.desc);
      return;
    }
    return res.data.data["recipeTags"];
  } catch (e) {
    console.log("食谱标签列表失败", e);
  }
}

// 品牌产品型号树
export async function loadBrandProductTree(vm) {
  try {
    let data = {
      brandOwnerCode: vm.$store.state.userInfo["brandOwnerCode"]
    };
    let res = await vm.$http.get(vm.$api.common.loadBrandProductTree, {
      params: data
    });
    if (res.data.status != 200) {
      vm.$message.error(res.data.desc);
      return;
    }
    vm.$store.commit(
      "ADD_BRAND_PRODUCT_TREE",
      res.data.data["brandProductTree"]
    );
  } catch (e) {
    console.log("品牌产品型号树失败", e);
  }
}

// 配件列表
export async function loadAccessory(vm, lang) {
  try {
    // const lang = vm.$i18n.locale.toUpperCase();
    // let res = await vm.$http.get(vm.$api.common.accessory, {
    let res = await vm.$http.get(vm.$api.accessory.list, {
      params: {onPage: false, lang}
    });
    if (res.data.status != 200) {
      vm.$message.error(res.data.desc);
      return;
    }
    const accessorys = res.data.data["accessorys"];
    return accessorys.map(item => {
      return {
        name: item.name,
        photo: item.xtPhoto ? item.xtPhoto : item.photo,
        code: item.code,
        accessoryCode: item.accessoryCode,
      }
    })
    // return res.data.data["accessorys"];
  } catch (e) {
    console.log("配件列表失败", e);
  }
}

// 食谱分类列表
export async function recipeCategoryList(vm, params = {}) {
  try {
    let data = {
      brandOwnerCode: vm.$store.state.userInfo.brandOwnerCode,
      onPage: false,
      ...params,
    };
    let res = await vm.$http.get(vm.$api.recipeCategory.list, { params: data });
    if (res.data.status != 200) {
      vm.$message.error(res.data.desc);
      return;
    }
    return res.data.data["recipeCategoryList"];
  } catch (e) {
    console.log("食谱分类列表失败", e);
  }
}

// 根据语言加载食谱标签
export function loadTagsByLang(vm, lang) {
  try {
    let data = {
      brandOwnerCode: vm.$store.state.userInfo.brandOwnerCode,
      lang: vm.$i18n.locale
    };

    if(lang) data["lang"] = lang;

    vm.$http.get(vm.$api.common.loadTagsByLang, { params: data }).then(res => {
      if (res.data.status != 200) {
        vm.$message.error(res.data.desc);
        return;
      }
      vm.$store.commit("ADD_RECIPE_TAG", res.data.data["tags"]);
    });
  } catch (e) {
    console.log("根据语言加载食谱标签失败", e);
  }
}

// 根据不同语言返回食谱制作模式做法
export function makeWayByLang(data, lang) {
  let { minute, second, temperature, rotateSpeed, rotateDirection } = data;
  let foreward = {
    ZH: "正转",
    EN: "foreward"
  }
  let reversal = {
    ZH: "反转",
    EN: "reversal"
  }
  let rotateDirectionName = rotateDirection == "0" ? foreward[lang] : reversal[lang];
  let langDesc = {
    ZH: `运行时间：${minute}分${second}秒，加热温度：${temperature}°C，旋转方向：${rotateDirectionName}，旋转速度：${rotateSpeed};`,
    EN: `Running time：${minute} minute${second} second，Heating temperature：${temperature} °C，Rotation direction：${rotateDirectionName}，Rotational speed：${rotateSpeed};`,
  };
  if (lang && langDesc[lang]) {
    return langDesc[lang];
  }
  return "";
}

// 加载食谱分类排名
export async function loadRecipeCategoryRanking(vm) {
  try {
    let data = {
      brandOwnerCode: vm.$store.state.userInfo["brandOwnerCode"]
    };
    let res = await vm.$http.get(vm.$api.common.loadRecipeCategoryRanking, {
      params: data
    });
    if (res.data.status != 200) {
      vm.$message.error(res.data.desc);
      return;
    }
    return res.data.data["recipeCategoryRankingList"];
  } catch (e) {
    console.log("加载食谱分类排名失败", e);
  }
}

// 加载品牌商食谱排名
export async function loadBrandRecipeRanking(vm) {
  try {
    let data = {
      brandOwnerCode: vm.$store.state.userInfo["brandOwnerCode"]
    };
    let res = await vm.$http.get(vm.$api.common.loadBrandRecipeRanking, {
      params: data
    });
    if (res.data.status != 200) {
      vm.$message.error(res.data.desc);
      return;
    }
    return res.data.data["recipeRankingList"];
  } catch (e) {
    console.log("加载品牌商食谱排名失败", e);
  }
}

// 加载品牌商首页统计数据
export async function loadBrandIndexCount(vm) {
  try {
    let data = {
      brandOwnerCode: vm.$store.state.userInfo["brandOwnerCode"]
    };
    let res = await vm.$http.get(vm.$api.common.loadBrandIndexCount, {
      params: data
    });
    if (res.data.status != 200) {
      vm.$message.error(res.data.desc);
      return;
    }
    return res.data.data["count"];
  } catch (e) {
    console.log("加载品牌商首页统计数据失败", e);
  }
}


/**
 * 过滤空参数，返回有值的字段
 * @param params
 * @returns {{}}
 */
export const filterParams = (params) => {
  let newParams = {};
  for (const key in params) {
    if (params[key]) {
      newParams[key] = params[key];
    }
  }
  return newParams;
}

/**
 * 根据产品型号配置返回可操作功能
 * 实现最小权限原则：当多个型号权限冲突时，以权限数量最少的型号为准
 * 空配置表示拥有全部权限，会参与最小权限比较
 *
 * @param {Array} productCodes - 选中的产品型号代码数组，如 ['d1a9d257eb1e482da0b3964f42fc7d1d', 'd2b9d257eb1e482da0b3964f42fc7d1e']
 * @param {Array} productConfigs - 产品型号配置数组，格式如下：
 *   [
 *     {
 *       "productModel": "3015",
 *       "productCode": "d1a9d257eb1e482da0b3964f42fc7d1d",
 *       "productConfParams": "HEAT_TEMP,SPRAY_LEVEL",
 *       "brandOwnerProductCode": "ee2123b8b4954de6b69c8b35f746d3ac",
 *       "productType": "SOUP"
 *     }
 *   ]
 * @returns {Array} 合并后的可操作功能参数数组
 *   ['HEAT_TEMP', 'SPRAY_LEVEL'] // 只包含所有型号都支持的参数
 */
export function getProductParams(productCodes, productConfigs) {
  // 参数验证
  if (!Array.isArray(productCodes) || productCodes.length === 0) {
    console.warn('产品型号数组不能为空');
    return [];
  }

  if (!Array.isArray(productConfigs) || productConfigs.length === 0) {
    console.warn('产品配置数组不能为空');
    return [];
  }

  // 功能字典常量
  const FUNCTION_CONSTANTS = {
    HEAT_TEMP: 'HEAT_TEMP',        // 加热温度
    ROTATE_DIR: 'ROTATE_DIRECTION', // 旋转方向
    ROTATE_SPEED: 'ROTATE_SPEED',   // 旋转速度
    SPRAY_LEVEL: 'SPRAY_LEVEL',     // 喷水档位
    TIME_UNIT: 'TIME_UNIT',         // 分/秒
    HOT_AIR: 'HOT_AIR',             // 热风
    HEAT_MODE: 'HEAT_MODE'          // 发热方式
  };

  // 所有可用的功能参数
  const ALL_FUNCTIONS = Object.values(FUNCTION_CONSTANTS);

  // 根据选中的产品型号代码找到对应的配置
  const selectedConfigs = productConfigs.filter(config =>
    productCodes.includes(config.productCode)
  );

  if (selectedConfigs.length === 0) {
    console.warn('未找到匹配的产品配置');
    return [];
  }

  // 检查是否所有型号的配置都为空（productConfParams为空或null）
  const allEmptyConfig = selectedConfigs.every(config =>
    !config.productConfParams || config.productConfParams.trim() === ''
  );

  if (allEmptyConfig) {
    console.log('检测到所有型号配置都为空，返回全部功能权限');
    return ALL_FUNCTIONS;
  }

  // 按权限数量排序，找到权限最少的型号
  // 空配置表示拥有全部权限，所以空配置的权限数量为全部功能数量
  const sortedConfigs = selectedConfigs.sort((a, b) => {
    const paramsA = a.productConfParams && a.productConfParams.trim() !== ''
      ? a.productConfParams.split(',').length
      : ALL_FUNCTIONS.length;
    const paramsB = b.productConfParams && b.productConfParams.trim() !== ''
      ? b.productConfParams.split(',').length
      : ALL_FUNCTIONS.length;
    return paramsA - paramsB;
  });

  // 以权限最少的型号配置为准
  const minModelConfig = sortedConfigs[0];

  // 如果最小型号配置为空，返回全部功能权限
  if (!minModelConfig || !minModelConfig.productConfParams || minModelConfig.productConfParams.trim() === '') {
    console.log('最小型号配置为空，返回全部功能权限');
    return ALL_FUNCTIONS;
  }

  // 解析最小型号支持的参数
  const minModelParams = minModelConfig.productConfParams
    .split(',')
    .map(param => param.trim())
    .filter(param => param);

  console.log('以权限最少的型号为准:', {
    minModel: minModelConfig.productModel,
    minModelParams: minModelParams,
    paramCount: minModelParams.length
  });

  return minModelParams;
}
